module.exports = __webpack_public_path__ + "media/7.8849a62f.wav";